export default function MySQL_ANDORNOT() {
  return (
    <div>
      <h2>MySQL_ANDORNOT</h2>    </div>
  );
}